import { useHistory } from 'react-router-dom';
import Parser from 'html-react-parser';
import l from '../../../lang';
import { Routes } from '../../../config/routes';
import TopDashboardSection from '../../common/top-dashboard-section';
import Card from '../../common/card';
import CardInfo from '../../common/card-info';
import Popup from '../../common/popup';
import AlertMessages from '../alert-messages';
import { ReactComponent as InfoIcon } from '../../../assets/icons/info-unfilled.svg';
import payoutsIcon from '../../../assets/icons/pay-png/payouts.png';
import contactsIcon from '../../../assets/icons/pay-png/contacts.png';
import fundTransferIcon from '../../../assets/icons/pay-png/fund-transfer.png';
import fundCryptoIcon from '../../../assets/icons/pay-png/fund-crypto.png';
import './styles.scss';

interface PayOption {
  id: string;
  labelKey: string;
  descKey: string;
  tooltipKey: string;
  route?: string;
  disabled?: boolean;
  badge?: 'new' | 'comingSoon';
  icon: React.ReactNode;
}

const Pay = () => {
  const history = useHistory();

  const options: PayOption[] = [
    {
      id: 'payouts',
      labelKey: 'menu.subItem.PAYOUTS',
      descKey: 'pay.payouts.desc',
      tooltipKey: 'pay.payouts.tooltip',
      route: Routes.PAYOUTS,
      icon: <img src={payoutsIcon} alt="" className="pay-hub__icon" aria-hidden />,
    },
    {
      id: 'contacts',
      labelKey: 'menu.subItem.PAYOUT_CONTACTS',
      descKey: 'pay.contacts.desc',
      tooltipKey: 'pay.contacts.tooltip',
      route: Routes.PAYOUT_CONTACTS,
      badge: 'new',
      icon: <img src={contactsIcon} alt="" className="pay-hub__icon" aria-hidden />,
    },
    {
      id: 'fund-transfer',
      labelKey: 'menu.subItem.PAY_FUND_TRANSFER',
      descKey: 'pay.fundTransfer.desc',
      tooltipKey: 'pay.fundTransfer.tooltip',
      disabled: true,
      badge: 'comingSoon',
      icon: <img src={fundTransferIcon} alt="" className="pay-hub__icon" aria-hidden />,
    },
    {
      id: 'fund-crypto',
      labelKey: 'menu.subItem.PAY_FUND_CRYPTO',
      descKey: 'pay.fundCrypto.desc',
      tooltipKey: 'pay.fundCrypto.tooltip',
      disabled: true,
      badge: 'comingSoon',
      icon: <img src={fundCryptoIcon} alt="" className="pay-hub__icon" aria-hidden />,
    },
  ];

  return (
    <div className="pay-hub">
      <TopDashboardSection title={l('menu.item.SIDEBAR_PAGAR')} subtitle={l('pay.subheadline')} />
      <AlertMessages />
      <Card className="pay-hub__card">
        <div className="pay-hub__grid" role="list">
          {options.map(option => (
            <CardInfo key={option.id} bottomElement={<div className="pay-hub__accent-line" />}>
              <button
                type="button"
                className={`pay-hub__item ${option.disabled ? 'pay-hub__item--disabled' : ''}`}
                role="listitem"
                aria-disabled={option.disabled || undefined}
                onClick={() => {
                  if (option.disabled || !option.route) return;
                  history.push(option.route);
                }}
              >
                <div className="pay-hub__info" onClick={e => e.stopPropagation()} onKeyDown={e => e.stopPropagation()}>
                  <Popup
                    text={Parser(l(option.tooltipKey))}
                    icon={<InfoIcon className="pay-hub__info-icon" aria-hidden />}
                  />
                </div>
                {option.badge && (
                  <span className={`pay-hub__badge pay-hub__badge--${option.badge}`}>{l(`common.tag.${option.badge}`)}</span>
                )}
                <div className="pay-hub__icon-wrap">{option.icon}</div>
                <div className="pay-hub__label">{l(option.labelKey)}</div>
                <div className="pay-hub__desc">{l(option.descKey)}</div>
              </button>
            </CardInfo>
          ))}
        </div>
      </Card>
    </div>
  );
};

export default Pay;
